import { ref, get, child, push, update, onValue } from 'firebase/database';

import { auth, db } from '../../firebase';

export const getSdgInfo = (params) => {
  ///${params?.slug}  lang,slug
  console.log({ hh: params });
  const h = new Promise((y, n) => {
    try {
      const dbRef = ref(db);
      get(child(dbRef, `/${params?.lang}/${params?.slug}`))
        .then((snapshot) => {
          if (snapshot.exists()) {
            console.log(snapshot.val());
            y({ data: snapshot.val() });
          } else {
            console.log('No data available');
            y({ data: null });
          }
        })
        .catch((error) => {
          //console.error(error);
          y({ data: null, error });
        });
    } catch (e) {
      y({ data: null, e });
    }
  });

  return h;
};

export const getSdgPhotos = (params) => {
  ///${params?.slug}  lang,slug
  console.log({ hh: params });
  const h = new Promise((y, n) => {
    try {
      const dbRef = ref(db);
      ///sdg/${sdg?.slug}
      get(child(dbRef, `/sdg/${params?.slug}`))
        .then((snapshot) => {
          if (snapshot.exists()) {
            console.log(snapshot.val());
            y({ data: snapshot.val() });
          } else {
            console.log('No data available');
            y({ data: null });
          }
        })
        .catch((error) => {
          //console.error(error);
          y({ data: null, error });
        });
      /*onValue(
          ref(db, `/${params?.lang}/${params?.slug}`),
          (snapshot) => {
            //const username = (snapshot.val() && snapshot.val().username) || 'Anonymous';
            if (snapshot.val()) {
              y({data:snapshot.val()});
            } else {
              n({data:{no:"data"}});
            }
          },
          {
            onlyOnce: true,
          },
        );*/
    } catch (e) {
      y({ data: null, e });
    }
  });

  return h;
};

export const getAllSdgPhotos = (params) => {
  ///${params?.slug}  lang,slug
  console.log({ hh: params });
  const h = new Promise((y, n) => {
    try {
      const dbRef = ref(db);
      ///sdg/${sdg?.slug}
      get(child(dbRef, `/sdg`))
        .then((snapshot) => {
          if (snapshot.exists()) {
            console.log(snapshot.val());
            y({ data: snapshot.val() });
          } else {
            console.log('No data available');
            y({ data: null });
          }
        })
        .catch((error) => {
          //console.error(error);
          y({ data: null, error });
        });
      /*onValue(
          ref(db, `/${params?.lang}/${params?.slug}`),
          (snapshot) => {
            //const username = (snapshot.val() && snapshot.val().username) || 'Anonymous';
            if (snapshot.val()) {
              y({data:snapshot.val()});
            } else {
              n({data:{no:"data"}});
            }
          },
          {
            onlyOnce: true,
          },
        );*/
    } catch (e) {
      y({ data: null, e });
    }
  });

  return h;
};

/*
export  const getSdg0 =  (params) => {
    ///${params?.slug}


    console.log({params}); 

    const h=  new Promise((y, n) => {
      try {
        setTimeout(()=>{

        const dbRef = ref(db, `/${params?.lang}`);
        onValue(
          dbRef,
          (snapshot) => {
            let r={};//[];
  snapshot.forEach((childSnapshot) => {
    const childKey = childSnapshot.key;
    const childData = childSnapshot.val();
     console.log({childData}); 
     //r.push(childData);
     r[childKey]=childData;
  });
  y({sdgs1:sdgs,data:r});
          },
          {
            onlyOnce: true,
          },
        );
        
        },3000);
      } catch (e) {
        console.log(e);
        n({ sdgs1:sdgs,data:{},e });
      }
    });
    return h;
  };*/
